/**
 * Frontend helpers for AI Lead Intake customer match UI.
 */

/**
 * Apply CRM preload or conflict resolution onto HITL fields.
 * @param {object} fields
 * @param {object|null} snapshot
 * @param {'use_customer'|'use_ai'} resolution
 * @param {object} [aiSnapshot] — original AI values before preload
 */
export function applyCustomerMatchResolution(
  fields = {},
  snapshot = null,
  resolution = "use_customer",
  aiSnapshot = null
) {
  if (resolution === "use_ai") {
    if (!aiSnapshot) return { ...fields };
    return {
      ...fields,
      name: aiSnapshot.name ?? fields.name,
      phone: aiSnapshot.phone ?? fields.phone,
      email: aiSnapshot.email ?? fields.email,
      address: aiSnapshot.address ?? fields.address,
    };
  }
  if (!snapshot) return { ...fields };
  return {
    ...fields,
    ...(snapshot.name ? { name: snapshot.name } : {}),
    ...(snapshot.phone ? { phone: snapshot.phone } : {}),
    ...(snapshot.email ? { email: snapshot.email } : {}),
    ...(snapshot.address ? { address: snapshot.address } : {}),
  };
}

/**
 * Capture AI contact fields before CRM preload (for conflict picker).
 */
export function captureAiContactSnapshot(fields = {}) {
  return {
    name: fields.name || "",
    phone: fields.phone || "",
    email: fields.email || "",
    address: fields.address || "",
  };
}
